import {forgeOrigin, urlPrefixed} from '../forgeApi';
import {
  ACCOUNT_SELECTOR_VALUE,
  LAST_ACCOUNT_SELECTOR_VALUE,
  LAST_NON_IMPERSONATED_ACCOUNT,
} from './accountModel';

const removeStorageItem = (
  storageName: 'localStorage' | 'sessionStorage',
  key: string
) => {
  try {
    window[storageName].removeItem(key);
  } catch {
    // Storage may be unavailable in private browsing or embedded contexts.
  }
};

/** Ends the OIDC session and returns to Forge, forgetting the selected account. */
export const shellLogout = async (isMock: boolean) => {
  removeStorageItem('localStorage', LAST_ACCOUNT_SELECTOR_VALUE);
  removeStorageItem('localStorage', LAST_NON_IMPERSONATED_ACCOUNT);
  removeStorageItem('sessionStorage', ACCOUNT_SELECTOR_VALUE);
  if (!isMock) {
    try {
      await fetch(urlPrefixed('/oidc/logout'), {
        method: 'DELETE',
        credentials: 'include',
      });
    } catch {
      // Always return to Forge, even if the logout request fails.
    }
  }
  window.location.href = forgeOrigin();
};
